import { render, staticRenderFns } from "./statisticCi.vue?vue&type=template&id=319451fc&scoped=true"
import script from "./statisticCi.vue?vue&type=script&lang=js"
export * from "./statisticCi.vue?vue&type=script&lang=js"
import style0 from "./statisticCi.vue?vue&type=style&index=0&id=319451fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319451fc",
  null
  
)

export default component.exports